import React from "react";

import { Icon, Text, Heading } from "@telia/teddy";
import TEXT from "../../../text-consts";
import "./SubscriptionBenefitsYoung.less";

const SubscriptionBenefitsYoung: React.FC = () => (
    <div className="subscription-benefits-young">
        <div className="subscription-benefits-young__content">
            <Heading mb="100" as="h3" variant="title-100" className="subscription-benefits-young__heading">
                <span className="subscription-benefits-young__icon">
                    <Icon name="bulb" />
                </span>
                {TEXT.AGE_BENEFITS.YOUNG.HEADING}
            </Heading>
            <Text mb="100" className="subscription-benefits-young__description">
                <span className="subscription-benefits-young__icon">
                    <Icon name="checkmark" />
                </span>
                {TEXT.AGE_BENEFITS.YOUNG.DESCRIPTION_2}
            </Text>
        </div>
    </div>
);

export default SubscriptionBenefitsYoung;
